export default ({ request }) => ({
  sysCustomerExportTemplateListApi(data = {}) {
    return request({
      url: '/sys/customer/export/template/list',
      method: 'post',
      data
    })
  },
  sysInoutTemplateListApi(data = {}) {
    return request({
      url: 'sys/sysInoutTemplate/list',
      method: 'post',
      data,
    })
  },
})
